import React from 'react';

import DisclosureDelivery, { DisclosureDeliveryHost } from 'app/shared/modules/DisclosureDelivery';

const LoanBundleHistory = () => <DisclosureDelivery host={DisclosureDeliveryHost.UNDERWRITING} />;

export default LoanBundleHistory;
